import * as React from "react";
const SvgDivider = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", overflow: "visible", style: {
  display: "block"
}, width: 16, height: 1, viewBox: "0 0 16 1", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Line 5386", d: "M0 0.5H16", stroke: "#C4C4C4" }));
export default SvgDivider;
